import { UserInfo } from '../../../api/dtos/user/UserProfile';
import { UserRoleResponse } from '../../../api/dtos/user/UserRoleResponse';
import { GlobalApiActionTypes } from '../types';

export interface UserProfileState {
    user: UserInfo,
    users: UserInfo[],
    isLoaded: boolean,
}

export const API_USER_PROFILE_LOADED = 'API_USER_PROFILE_LOADED';
export const API_USER_NAME_UPDATED = 'API_USER_NAME_UPDATED';
export const API_USER_PASSWORD_UPDATED = 'API_USER_PASSWORD_UPDATED';

interface ApiUserProfileLoadedAction {
    type: typeof API_USER_PROFILE_LOADED,
    user: UserInfo
}
interface ApiUserNameUpdatedAction {
    type: typeof API_USER_NAME_UPDATED;
    name: string;
}
interface ApiUserPasswordUpdatedAction {
    type: typeof API_USER_PASSWORD_UPDATED;
    password: string;
}

//management
export const API_USER_REGISTER = 'API_USER_REGISTER';
export const API_USERS_LOADED = 'API_USERS_LOADED';
export const API_USER_ROLE_UPDATED = 'API_USER_ROLE_UPDATED';
export const API_USER_REMOVED = 'API_USER_REMOVED';

interface ApiUserRegister {
    type: typeof API_USER_REGISTER;
    email: string;
    role: UserRoleResponse;

}
interface ApiUsersLoadedAction {
    type: typeof API_USERS_LOADED;
    users: UserInfo[];
}

interface ApiUserRoleUpdatedAction {
    type: typeof API_USER_ROLE_UPDATED;
    userId: number;
    role: UserRoleResponse;
}

interface ApiUserRemovedAction {
    type: typeof API_USER_REMOVED;
    userId: number;
}
export type ApiUserProfileActionTypes = 
    GlobalApiActionTypes
    | ApiUserProfileLoadedAction
    | ApiUserNameUpdatedAction
    | ApiUserPasswordUpdatedAction
    | ApiUsersLoadedAction
    | ApiUserRoleUpdatedAction
    | ApiUserRemovedAction
    | ApiUserRegister;
